import { render, staticRenderFns } from "./rateList.vue?vue&type=template&id=5fca56f7&scoped=true&"
import script from "./rateList.vue?vue&type=script&lang=js&"
export * from "./rateList.vue?vue&type=script&lang=js&"
import style0 from "./rateList.vue?vue&type=style&index=0&id=5fca56f7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca56f7",
  null
  
)

export default component.exports